<template>
  <div>
    <div v-if="notificationsEnabled">
      <br>
      <textarea v-model="message" cols="30" rows="10" placeholder="Введите уведомление для всех пользователей"></textarea>
      <br>
      <button @click="createPushNotification">Отправить всем</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PushServiceAdmin',
  data() {
    return {
      notificationsEnabled: true,
      message: null,
      VAPID_PUBLIC_KEY: 'BD_rWfoSr2v8SQpn4_gWzZvEZxnWp5mvxsGUGl2A_P-51Bk6ejOj0YL7Nrg3dlgHoGAWbOSycurrhnmtu-OYRUU'
    }
  },
  created() {
    this.initSW();
  },
  methods: {
    createPushNotification() {
        // get the textarea content and send it to the server.
        // The server will create a notifications that will be pushed
        return axios.post(`/api/notify`, {
            message: this.message,
        })
        .then(response => {
            this.message = null
        })
    },    
    initSW() {
      if (!("serviceWorker" in navigator)) {
        console.error("Service worker is not supported in your browser!");
        return;
      }
      if (!("PushManager" in window)) {
        console.error("Push manager is not supported in your browser!");
        return;
      }
      navigator.serviceWorker.register('/sw.js')
        .then(() => {
          console.log('serviceWorker installed!');
          this.initPush();
        })
        .catch(err => {
          console.log(err);
        });
    },

    initPush() {
      if (!navigator.serviceWorker.ready) {
        return;
      }

      new Promise((resolve, reject) => {
        const permissionResult = Notification.requestPermission(result => {
          resolve(result);
        });

        if (permissionResult) {
          permissionResult.then(resolve, reject);
        }
      })
      .then(permissionResult => {
        if (permissionResult !== 'granted') {
          throw new Error("We weren't granted permission.");
        }
        this.subscribeUser();
      });
    },

    subscribeUser() {
      navigator.serviceWorker.ready
        .then(registration => {
          const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: this.urlBase64ToUint8Array(
              this.VAPID_PUBLIC_KEY
            )
          };

          return registration.pushManager.subscribe(subscribeOptions);
        })
        .then(pushSubscription => {
          console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
          this.storePushSubscription(pushSubscription);
        });
    },

    urlBase64ToUint8Array(base64String) {
      var padding = '='.repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

      var rawData = window.atob(base64);
      var outputArray = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },

    storePushSubscription(pushSubscription) {
      axios.post('/api/push', pushSubscription)
      .then(res => {
        console.log('Push subscription saved successfully');
      })
      .catch(err => {
        // Don't show error to user for push subscription failures
        console.warn('Failed to save push subscription:', err.response?.data?.message || 'Unknown error');
      });
    }
  },
}
</script>

<style scoped>
  /* Your styles here if any */
</style>